/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  CompareShare,
  CompareShareInput,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create a short share URL for a comparison
 */
export const compareShare = (
    compareShareInput: MaybeRefOrGetter<CompareShareInput>,
 signal?: AbortSignal
) => {
      compareShareInput = toValue(compareShareInput);

      return axiosClient<CompareShare>(
      {url: `/compare/share`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: compareShareInput, signal
    },
      );
    }




export const getCompareShareMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof compareShare>>, TError,{data: CompareShareInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof compareShare>>, TError,{data: CompareShareInput}, TContext> => {

const mutationKey = ['compareShare'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof compareShare>>, {data: CompareShareInput}> = (props) => {
          const {data} = props ?? {};

          return  compareShare(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompareShareMutationResult = NonNullable<Awaited<ReturnType<typeof compareShare>>>
    export type CompareShareMutationBody = CompareShareInput
    export type CompareShareMutationError = ErrorType<StandardError>

    /**
 * @summary Create a short share URL for a comparison
 */
export const useCompareShare = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof compareShare>>, TError,{data: CompareShareInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof compareShare>>,
        TError,
        {data: CompareShareInput},
        TContext
      > => {
      return useMutation(getCompareShareMutationOptions(options), queryClient);
    }
